import roomReducerDefaultState from '../../dataStore/reducers/room/defaultState'

/** Determines whether the current presenter is focused or not */
export default function (BTUser: string, focusOn: string | null) {

  if (focusOn === roomReducerDefaultState.focusOn) return false
  return BTUser === focusOn

}
